export class ApiError extends Error {
  public readonly status: number
  public readonly statusText: string
  public readonly data: unknown

  constructor(
    message: string,
    status: number,
    statusText: string,
    data: unknown = null,
  ) {
    super(message)

    this.name = 'ApiError'
    this.status = status
    this.statusText = statusText
    this.data = data
  }
}

export async function apiRequest<T>(
  url: string,
  options: RequestInit = {},
): Promise<T> {
  const headers = new Headers(options.headers)

  if (
    options.body !== undefined &&
    options.body !== null &&
    !(options.body instanceof FormData) &&
    !headers.has('Content-Type')
  ) {
    headers.set('Content-Type', 'application/json')
  }

  headers.set('Accept', 'application/json')

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  })

  if (!response.ok) {
    let data: unknown = null

    try {
      data = await response.json()
    } catch {
      try {
        data = await response.text()
      } catch {
        data = null
      }
    }

    console.error('Kraken API error:', {
      url,
      status: response.status,
      statusText: response.statusText,
      data,
    })

    let message =
      `API request failed: ${response.status} ${response.statusText}`

    if (
      typeof data === 'object' &&
      data !== null &&
      'detail' in data &&
      typeof data.detail === 'string'
    ) {
      message = data.detail
    }

    throw new ApiError(
      message,
      response.status,
      response.statusText,
      data,
    )
  }

  if (response.status === 204) {
    return undefined as T
  }

  return response.json() as Promise<T>
}
